import React from "react";
import { useLocation } from "react-router-dom";
import MPMCModuleSubtopic from "../MPMCModuleSubtopic";

const MPMC_SerialCommunication = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <MPMCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Serial Communication"
      videos={[
        "https://www.youtube.com/embed/fCRActJDR9U", // Serial Communication in 8051 Microcontroller
        "https://www.youtube.com/embed/hPhMz9eWMC8", // SCON Register in 8051 Microcontroller
        "https://www.youtube.com/embed/LD2Fbhk2fAI", // Serial Communication Programming for 8051
        "https://www.youtube.com/embed/VJvNQNwFq30", // 8051 Serial Communication Program to transfer HELLO
        "https://www.youtube.com/embed/9nLs99ZWC2E", // Serial communication receiving using 8051 ALP
      ]}
      takeaways={[
        { text: "The basic serial communication code structure remains the same." },
        { text: "Baud rate changes require modifying the TH register value." },
        { text: "For a baud rate of 19200, remember to use the PCON register." },
      ]}
      questions={[
        "An 8051 microcontroller operating with crystal frequency of 11.0592 MHz is connected to a switch at P1.0. Write an ALP to monitor the status of switch for every 1ms after successful transmission of the message. If the switch is open, then transmit a string “PLACE TO LEARN” stored at ROM location of 200H at 9600 baud rate. If the switch is closed, then transmit a string “CHANCE TO GROW” stored at ROM location 400H at 4800 baud rate. Use timer for the delay generation. Assume the overhead delay caused due to transmission of string is negligible.",
        "Develop a program to receive data until the received data is “N”, means if 8051 receives “N” then it should stop receiving the character. Baud rate of 9600.",
      ]}
      exampleVideos={[]} // No example question videos provided
    />
  );
}

export default MPMC_SerialCommunication;
